import { Step } from 'react-joyride';

export const recordsTourSteps: Step[] = [
  {
    target: '[data-tour="records-header"]',
    content: (
      <div>
        <h4>Chat Records</h4>
        <p>
          Access historical conversations and chat transcripts. Search through past interactions and
          review customer communication history.
        </p>
      </div>
    ),
    placement: 'bottom',
    disableBeacon: true
  },
  {
    target: '[data-tour="records-search"]',
    content: (
      <div>
        <h4>Search Records</h4>
        <p>
          Search by customer name, agent, date, or conversation content to quickly find specific
          chat records.
        </p>
      </div>
    ),
    placement: 'bottom'
  },
  {
    target: '[data-tour="records-filter"]',
    content: (
      <div>
        <h4>Filter Options</h4>
        <p>Filter records by date range, agent, customer, or conversation status.</p>
      </div>
    ),
    placement: 'bottom'
  },
  {
    target: '[data-tour="records-table"]',
    content: (
      <div>
        <h4>Records List</h4>
        <p>
          View all conversation records with timestamps, participants, and quick access to full
          transcripts.
        </p>
      </div>
    ),
    placement: 'top'
  }
];
